import actionConstants from '../constants/ActionConstants';
import { setSystemInfoApiCall } from '../../api/apiCallsCustomer';
import ActionDispatcher from '../../api/ActionDispatcher';

const editSystemOrDeviceAction = (buildingInfoId, systemInfo) =>
  ActionDispatcher(
    setSystemInfoApiCall.bind(null, buildingInfoId, systemInfo),
    actionConstants.EDIT_SYSTEM_OR_DEVICE_SUCCESS,
    actionConstants.EDIT_SYSTEM_OR_DEVICE_FAILURE,
    actionConstants.EDIT_SYSTEM_OR_DEVICE_REQUEST
  );

export { editSystemOrDeviceAction };
